import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
type SelectFieldProps = {
  label: string;
  name: string;
  options: {
    value: string;
    label: string;
  }[];
  placeholder?: string;
  error?: string;
  className?: string;
} & Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'name' | 'className'>;
export function SelectField({
  label,
  name,
  options,
  placeholder,
  error,
  className = '',
  id,
  ...rest
}: SelectFieldProps) {
  const fieldId = id ?? `f-${name}`;
  return <div className={className} data-id="element-204" data-mp="rhc5e8sf5t59">
      <label htmlFor={fieldId} className="block text-[0.7rem] font-medium uppercase tracking-[0.2em] text-charcoal" data-id="element-205" data-mp="rh2emizjvhyi">
        {label}
      </label>
      <div className="relative mt-2" data-id="element-206" data-mp="mkbyxwrnqodm">
        <select id={fieldId} name={name} aria-invalid={error ? true : undefined} aria-describedby={error ? `${fieldId}-err` : undefined} className="field appearance-none pr-10" {...rest} data-id="element-207" data-mp="hjnwmexzal43">
          {placeholder && <option value="" disabled data-id="element-208" data-mp="3et9e2hb8ksmh">
              {placeholder}
            </option>}
          {options.map(o => <option key={o.value} value={o.value} data-id="element-209" data-mp="3itjvcq4hb5gn">
              {o.label}
            </option>)}
        </select>
        <ChevronDownIcon aria-hidden="true" strokeWidth={1.25} className="pointer-events-none absolute right-4 top-1/2 h-4 w-4 -translate-y-1/2 text-charcoal" data-id="element-210" data-mp="34uk5jf58ckiw" />
      </div>
      {error && <p id={`${fieldId}-err`} className="mt-2 text-sm text-[#9B2C2C]" data-id="element-211" data-mp="2v3fswm311br8">
          {error}
        </p>}
    </div>;
}